import { DAY } from '@vuddy/utils';
import { removeCookie, setCookie } from '@vuddy/utils/src/cookie';
import { env } from 'next-runtime-env';

const getBrowserPublicEnv = (key: string) => {
  if (typeof window === 'undefined') {
    return undefined;
  }

  return (window as typeof window & { __ENV?: Record<string, string> }).__ENV?.[
    key
  ];
};

const inferPhaseFromHost = () => {
  if (typeof window === 'undefined') {
    return undefined;
  }

  const { hostname } = window.location;

  if (hostname.includes('sandbox')) {
    return 'sandbox';
  }

  if (hostname === 'vuddy.io' || hostname.endsWith('.vuddy.io')) {
    return 'production';
  }

  if (hostname.includes('dev') || hostname.includes('local')) {
    return 'dev';
  }

  return undefined;
};

const inferCookieDomainFromHost = () => {
  if (typeof window === 'undefined') {
    return undefined;
  }

  const { hostname } = window.location;

  if (hostname === 'vuddy.io' || hostname.endsWith('.vuddy.io')) {
    return '.vuddy.io';
  }

  if (hostname.endsWith('.vuddy.codes')) {
    return '.vuddy.codes';
  }

  return undefined;
};

const getPhase = () => {
  const runtimePhase =
    getBrowserPublicEnv('NEXT_PUBLIC_PHASE') ?? env('NEXT_PUBLIC_PHASE');
  return (
    runtimePhase ??
    process.env.NEXT_PUBLIC_PHASE ??
    inferPhaseFromHost() ??
    'dev'
  );
};

export const getAccessTokenCookieName = () => {
  const phase = getPhase();
  return phase === 'production' || phase === 'internal-production'
    ? 'accessToken'
    : `accessToken_${phase}`;
};

const DefaultOption = {
  path: '/',
  domain:
    getBrowserPublicEnv('NEXT_PUBLIC_AUTH_COOKIE_DOMAIN') ??
    env('NEXT_PUBLIC_AUTH_COOKIE_DOMAIN') ??
    process.env.NEXT_PUBLIC_AUTH_COOKIE_DOMAIN ??
    inferCookieDomainFromHost(),
};

export const setToken = (accessToken: string) => {
  if (accessToken) {
    const expireDate = new Date(Date.now() + DAY * 2);
    const options = {
      ...DefaultOption,
      expires: expireDate,
    };
    setCookie(getAccessTokenCookieName(), accessToken, options);
  }
};

export const removeToken = () => {
  removeCookie(getAccessTokenCookieName(), DefaultOption);
};
